export default __webpack_public_path__ + "static/media/juniorHunter.19dab188.svg";